import isFunction from "lodash/isFunction";
import reduce from "lodash/reduce";
import size from "lodash/size";
import words from "lodash/words";
import get from "lodash/get";
import PropTypes from "prop-types";
import React, { cloneElement, Component } from "react";

import { createSanitizedMarkup, getTextFromNode } from "../../utils/Utils";

export default class Truncate extends Component {
    constructor() {
        super();

        this.state = {
            isComputed: false,
            truncatedText: "",
            shouldTruncateText: false,
        };

        this.onClickMore = this.onClickMore.bind(this);
        this.onInitialChildrenRef = this.onInitialChildrenRef.bind(this);
    }

    onClickMore(event) {
        const { onAfterClickMore } = this.props;

        this.setState(() => {
            if (isFunction(onAfterClickMore)) {
                onAfterClickMore();
            }

            return { shouldTruncateText: false };
        });
        event.preventDefault();
    }

    onInitialChildrenRef(ref) {
        if (!this.state.isComputed) {
            const { characters, thresholdRatio } = this.props;
            const orginalText =
                get(this.props, "children.props.dangerouslySetInnerHTML.__html") || getTextFromNode(ref);
            const truncatedText = Truncate.computeTruncatedText(orginalText, characters);
            const threshold = characters * thresholdRatio;
            const shouldTruncateText = size(truncatedText) + threshold < size(orginalText);

            this.setState(() => ({
                isComputed: true,
                shouldTruncateText,
                truncatedText,
            }));
        }
    }

    static computeTruncatedText(orginalText, characters) {
        let truncationFinished = false;

        return reduce(words(orginalText, /[^, ]+/g), (acc, word) => {
            const shouldAppenWord = size(`${acc} ${word}`) < characters && !truncationFinished;

            truncationFinished = !shouldAppenWord;

            return shouldAppenWord ? `${acc} ${word}` : acc;
        });
    }

    render() {
        const { isComputed, shouldTruncateText, truncatedText } = this.state;
        const { children, ellipsis } = this.props;

        if (isComputed) {
            return shouldTruncateText ? (
                <span>
                    <p className="body" dangerouslySetInnerHTML={createSanitizedMarkup(truncatedText)} />

                    {cloneElement(ellipsis, { onClick: this.onClickMore })}
                </span>
            ) : (
                cloneElement(children)
            );
        }

        /*
         * We briefly return the original children so we can get the HTML node for it which will be
         * then used to get the text out of it.
         */
        return cloneElement(children, { ref: this.onInitialChildrenRef });
    }
}

Truncate.defaultProps = {
    characters: 100,
    ellipsis: <span>...</span>,
    onAfterClickMore: undefined,
    /*
     * thresholdRatio is used to decide if it's worth truncating the text or not;
     * by default it makes sure that we only render the ellipsis if the remaining text (after
     * truncation) has more characters than the truncated text;
     * For example:
     * - if we truncate at 100 chars, but the original text has 199, then we don't show the ellipsis
     * - if we truncate at 100 chars, but the original text has 201, then we show the ellipsis
     *
     * If you want your text to be always truncated at numbers of <characters>, just set it to 0.
     */
    thresholdRatio: 1,
};

Truncate.propTypes = {
    characters: PropTypes.number,
    children: PropTypes.node.isRequired,
    ellipsis: PropTypes.node,
    onAfterClickMore: PropTypes.func,
    thresholdRatio: PropTypes.number,
};
